'use client';

import { useCallback, useEffect, useRef, useState } from 'react';

import { styles } from './UiToolSliderFading.styles';

export interface UiToolSliderFadingProps {
  className?: string;
  children?: React.ReactNode;
  containerClassName?: string;
}

export function UiToolSliderFading({
  children,
  className,
  containerClassName
}: UiToolSliderFadingProps) {
  const wrapperRef = useRef<HTMLDivElement>(null);
  const contentRef = useRef<HTMLDivElement>(null);
  const [isActive, setIsActive] = useState(false);

  const slots = styles({ active: isActive });

  const checkActive = useCallback(() => {
    const content = contentRef.current;
    const container = wrapperRef.current;

    if (!content || !container) {
      setIsActive(false);
      return;
    }

    const { paddingLeft, paddingRight } = window.getComputedStyle(content);
    const horizontalPadding =
      Number.parseFloat(paddingLeft) + Number.parseFloat(paddingRight);
    const contentWidth = content.scrollWidth - horizontalPadding;

    setIsActive(contentWidth - container.clientWidth > 1);
  }, []);

  useEffect(() => {
    const timer = window.setTimeout(() => {
      checkActive();
    }, 0);

    let resizeTimer: number;
    const handleResize = () => {
      clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(() => {
        checkActive();
      }, 300);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      clearTimeout(timer);
      clearTimeout(resizeTimer);
      window.removeEventListener('resize', handleResize);
    };
  }, [checkActive]);

  return (
    <div
      ref={wrapperRef}
      className={slots.base({ className })}
    >
      <div
        ref={contentRef}
        className={slots.first({
          className: containerClassName
        })}
      >
        {children}
      </div>
      {isActive && (
        <div
          className={slots.second({
            className: containerClassName
          })}
        >
          {children}
        </div>
      )}
    </div>
  );
}
